import { render, staticRenderFns } from "./AMXButton.vue?vue&type=template&id=66ac48ba&scoped=true&"
import script from "./AMXButton.vue?vue&type=script&lang=ts&"
export * from "./AMXButton.vue?vue&type=script&lang=ts&"
import style0 from "./AMXButton.vue?vue&type=style&index=0&id=66ac48ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ac48ba",
  null
  
)

export default component.exports